/**
 * Service Template Constants
 */

/**
 * Authentication type constants
 * These should match the IDs from your backend authentication types lookup
 */
export const AUTH_TYPES = {
	OAUTH2_USERNAME_PASSWORD: 1,
	OAUTH2_CLIENT_CREDENTIALS: 2,
	API_KEY: 3,
	JWT: 4
}

/**
 * Template categories for organizing templates
 */
export const TEMPLATE_CATEGORIES = {
	CRM: 'CRM',
	MARKETING: 'Marketing',
	ECOMMERCE: 'E-commerce',
	COMMUNICATION: 'Communication',
	PAYMENT: 'Payment',
	PRODUCTIVITY: 'Productivity',
	SUPPORT: 'Support',
	ANALYTICS: 'Analytics',
	CONTENT_MANAGEMENT: 'Content Management',
	CUSTOMER_ENGAGEMENT: 'Customer Engagement',
	NOTIFICATIONS: 'Notifications',
	GENERIC: 'Generic'
}
